<template>
    <div class="advanced-config">
        <p
            :class="`advanced-config-activator ${isOpen ? 'open' : 'closed'}`"
            @click="openConfigs"
        >
            {{ $t("message.generics.message.advancedSettings") }}
        </p>

        <div v-if="isOpen" :class="`advanced-config-fields`">
            <div
                class="advanced-config-fields-field advanced-config-fields-integration"
            >
                <v-checkbox
                    v-model="value.isBirthdate"
                    :label="
                        $t('message.campaigns.message.showOnlyToBirthdayPerson')
                    "
                    @change="emitInput($event, 'isBirthdate')"
                ></v-checkbox>

                <v-checkbox
                    v-if="!isPartner"
                    v-model="linkIntegration"
                    :ripple="false"
                    :label="$t('message.campaigns.message.linkIntegration')"
                    @change="checkIfRemovingIntegration"
                ></v-checkbox>

                <Select
                    v-if="linkIntegration && !isPartner"
                    :data-title="$t('message.campaigns.message.integration')"
                    v-model="integrationId"
                    data-max-height="180px"
                    :no-results="noResults"
                    :data-items="integrationsSelectOptionsWithFilter"
                    @search="(v) => search(v)"
                    @input="emitInput($event, 'integrationTrigger')"
                ></Select>

                <v-checkbox
                    v-if="!isPartner"
                    v-model="value.allCaptiveLoginTypeSelected"
                    :ripple="false"
                    :label="$t('message.campaigns.message.allTypesOfForms')"
                    @change="emitInput($event, 'allCaptiveLoginTypeSelected')"
                ></v-checkbox>

                <advertising-modal-advanced-config-captive-forms-filter
                    v-if="!value.allCaptiveLoginTypeSelected && !isPartner"
                    :value="value.captiveLoginTypeFilter"
                    :list="captiveFormsList"
                    @input="emitInput($event, 'captiveLoginTypeFilter')"
                />

                <SSIDFilter
                    v-if="!isPartner"
                    :value="value.ssidFilter"
                    :is-all-selected="value.allSsidSelected"
                    @update-all-selected="emitInput($event, 'allSsidSelected')"
                    @input="emitInput($event, 'ssidFilter')"
                />
            </div>
        </div>

        <p
            v-if="isOpen"
            :class="`advanced-config-activator advanced-config-activator_close`"
            @click="closeConfigs"
        >
            {{ $t("message.campaigns.message.seeLess") }}
        </p>
    </div>
</template>

<script>
import Select from "@components/Select";
import vModel from "@mixins/v-model";
import { cloneDeep } from "lodash";
import AdvertisingModalAdvancedConfigCaptiveFormsFilter from "@components/modules/advertising/modal/advanced-config/captive-forms-filter/AdvertisingModalAdvancedConfigCaptiveFormsFilter";
import SSIDFilter from "@components/modules/ssid/SSIDFilter.vue";

export default {
    components: {
        Select,
        AdvertisingModalAdvancedConfigCaptiveFormsFilter,
        SSIDFilter,
    },

    data() {
        return {
            isOpen: false,
            linkIntegration: false,
            anuncianteId: undefined,
            integrationId: undefined,
            filteredList: [],
            searchedText: undefined,
            noResults: false,
            showAdvertisingToAllTypesOfForms: true,
            captiveFormsList: [],
            loading: false,
        };
    },

    props: {
        value: {
            type: Object,
            default() {
                return {
                    anuncianteId: undefined,
                    integrationTrigger: undefined,
                    isBirthdate: false,
                    allCaptiveLoginTypeSelected: true,
                    captiveLoginTypeFilter: [],
                    ssidFilter: [],
                };
            },
        },
    },

    watch: {
        allCaptiveLoginTypeSelected(val) {
            if (!val) {
                this.pushAllCaptiveFormsIdsToFilterList();
                this.emitInput(
                    this.captiveLoginTypeFilter,
                    "captiveLoginTypeFilter"
                );
            } else {
                this.emitInput([], "captiveLoginTypeFilter");
            }
        },
    },

    computed: {
        permissions() {
            return this.$store.state.users.user.permissions;
        },
        integrations() {
            return (
                this.$store.state.integration.listIntegrationsAccessExecution ||
                []
            );
        },
        integrationsSelectOptions() {
            return this.integrations.map((integration) => {
                return {
                    id: integration.id,
                    label: integration.name,
                };
            });
        },
        integrationsSelectOptionsWithFilter() {
            return this.filteredList.length > 0
                ? this.filteredList
                : this.integrationsSelectOptions;
        },
        allCaptiveLoginTypeSelected() {
            return this.value.allCaptiveLoginTypeSelected;
        },
        isPartner() {
            return (
                this.$store.state.users.user &&
                this.$store.state.users.user.tipo === "PARCEIRO"
            );
        },
    },

    methods: {
        checkIfRemovingIntegration(val) {
            if (!val) {
                this.emitInput(null, "integrationTrigger");
                this.integrationId = null;
            }
        },
        openConfigs() {
            this.isOpen = true;
        },
        closeConfigs() {
            this.isOpen = false;
        },
        emitInput(val, key) {
            const value = cloneDeep(this.value);

            value[key] = val;

            this.$emit("input", value);
        },
        search(search) {
            if (!search) {
                this.noResults = false;
            }
            this.searchedText = search;
            this.filteredList = this.integrationsSelectOptions.filter((item) =>
                item.label.toLowerCase().includes(search.toLowerCase())
            );
            if (this.filteredList.length < 1) this.noResults = true;
        },
        async loadCaptiveForms() {
            try {
                this.loading = true;

                const loginTypes = await this.$api.core.loginTypes.list();

                this.captiveFormsList = loginTypes;

                this.loading = false;
            } catch (e) {
                console.log(e);
            }
        },

        pushAllCaptiveFormsIdsToFilterList() {
            this.captiveLoginTypeFilter = [];
            this.captiveFormsList.map((item) =>
                this.captiveLoginTypeFilter.push(item.id)
            );
        },
    },

    mixins: [vModel],

    async mounted() {
        if (!this.isPartner) {
            await this.loadCaptiveForms();
        }
        await this.$loader.integrations.loadIntegrationsAccessExecution();

        if (
            this.value.anuncianteId !== undefined &&
            this.value.anuncianteId !== null
        ) {
            this.anuncianteId = this.value.anuncianteId;
        }

        if (
            this.value.integrationTrigger !== undefined &&
            this.value.integrationTrigger !== null
        ) {
            this.integrationId = this.value.integrationTrigger;
            this.linkIntegration = true;
        }
    },

    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.advanced-config {
    width: 100%;
    .advanced-config-activator {
        color: $selected;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 500;
        text-align: center;

        &.advanced-config-activator_close {
            font-size: 14px;
        }

        &.open {
            cursor: default;
            color: $color-muted;
            text-decoration: none;
        }
    }

    .advanced-config-fields {
        /* display: flex;
    justify-content: center; */
        margin: 0 auto;
        width: 100%;
        margin-bottom: 15px;

        .v-input {
            display: flex;
            justify-content: center;
            font-weight: 500;
            font-size: 14px !important;
        }

        .advanced-config-fields-field {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
</style>
